import { FormattedMessage } from 'react-intl';
import styled from 'styled-components';
import { Icons } from '../type';
import { TextCSS } from './Text';
import { ReactNode } from 'react';

const Wrapper = styled.div`
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  gap: 2vmin;
  padding: 0 4vmax;
  text-align: center;
`;
const H2 = styled.h2`
  ${TextCSS({ size: 'L' })}
  margin: 0;
`;
const Description = styled.div`
  ${TextCSS({})}
`;
const Img = styled.img`
  width: ${(props) => `15${props.theme.unit}`};
`;

export const Empty = ({
  icon,
  title,
  description,
  children,
}: {
  icon?: Icons;
  title: string;
  description?: string;
  children?: ReactNode;
}) => {
  return (
    <Wrapper>
      {icon && (
        <Img src={`${process.env.PUBLIC_URL}/images/${icon}.webp`} alt="" />
      )}
      <H2>
        <FormattedMessage id={title} />
      </H2>
      {description && (
        <Description>
          <FormattedMessage id={description} />
        </Description>
      )}
      {children}
    </Wrapper>
  );
};
